<template>
   <div>
      <audio style="width:100%; height: 35px" controls="controls" :src="file_data"  type="audio/mp3"
             controlsList="nodownload"
             @play="player_event" @seeked="player_event" @pause="player_event"
             @volumechange="player_event"
             ref="mp3_player"
             preload="none"
      ></audio>
   </div>
</template>

<script>
export default {
   name: "AudioPlayer",
   props:{
      file: String,
      type: String,
      path: {type: String, default: null}
   },

   data(){
      return {
         // file_data: require('../media/en/radio/living_the_bible/001_Who_Created_the_World_d_dnn.mp3')
      }
   },

   computed:{
     file_data(){

        let base_url = 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/radio/livingthebible/'
        if (this.type === 'LTB'){
           base_url = 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/radio/livingthebible/'
        }
        else if (this.type === 'LTBQ'){
           base_url = 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/radio/livingthebible-q/'
        }

        else if (this.type === 'JP_LTB'){
           base_url = 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/jp/radio/livingthebible/'
        }


        if (this.path != null){
           base_url = this.path;
        }


        let file = base_url + this.file;

        if (this.file != null){
           return  file;
        }
        else{
           return '';
        }

     }
   },
   methods: {
      player_event(){

      }
   }
}
</script>

<style scoped>

</style>